/*
  Elto Added By Antonio Vargas
  @copyright Antonio Vargas <localhost.80@gmail.com>
  @version initial
*/

function yanteiAltText() {
  var box = jQuery('.small-promos').first().find('.columns.large-3').first();
  var alt = box.find('.yantei-alt');
  var boxWidth = box.width();
  alt.css({'padding':((43*boxWidth)/395),'font-size':((34*boxWidth)/395)})
  box.nextAll().each(function() {
    jQuery(this).find('.yantei-alt').css('font-size',((42*boxWidth)/395))
  });
}

if(jQuery != undefined){

    // Setup Loading Message
    jQuery(document).ajaxStart(function(){
        jQuery('.actual-content').css('display', 'none');
        jQuery('.ajax-loading').fadeOut(0).fadeIn(500);
    });

    jQuery(document).ajaxComplete(function(){
        jQuery('.ajax-loading').fadeOut(500, function(){
            jQuery('.actual-content').css('display', 'block');
        });
    });
  
    jQuery(document).ready(function($){
      var basket = $.cookie('inquiry_basket');
      if (typeof(basket)!='undefined') {
        var split = new Array();

        split = basket.split(',');
        var item_count = 0;
        for (i in split)
          if (split[i].length) item_count++;
        if (item_count)
        {
          var inquiryCartLink = $('.cart-link');
          if (inquiryCartLink.find('div').length==0)
            inquiryCartLink.append('<div>'+item_count+'</div>');
        }
      }
      
      if (jQuery('.small-promos .yantei-alt').length) {
        yanteiAltText();
        jQuery(window).resize(function() {
          yanteiAltText();
        });
      }

       
    });


    // Turn Automatic JSON parsing for cookies


    // Product Variant Inquery Framework
    var InquiryFramework = new function(){
        var inquiry_basket = new Array();

        // Initialize checks
        this.init = function(){

            if(jQuery.cookie('inquiry_basket') == undefined){
                this.createNewBasket();
            }

            if(jQuery('.add-variant-basket').length > 0){
                var items = this.getInquiryBasketItems();
                
                jQuery('.add-variant-basket').each(function(index){
                    var parent = $(this).parent();
                    var element = $(this);
                    var variant_id = element.data('variant-id');
                    var product_handle = element.data('product-handle');
                    var product = product_handle+':'+variant_id;
                    var found = false;

                    jQuery.each(items, function(key, val){
                        if(val == product){
                            found = true;
                        }
                    });

                    if(found == true){
                        element.data('in-basket', true);
                        element.fadeOut(0);
                        parent.find('.remove-variant-basket').fadeOut(0, function(){
                            $(this).fadeIn(500);
                        });
                    }else{
                        element.data('in-basket', false);
                        parent.find('.remove-variant-basket').fadeOut(0);
                        element.fadeIn(500);
                    }
                });
            }
        }

        // show notifications
        this.showNotification = function(str){
            if(str.length > 0){
                jQuery('.framework-notices').html(str);
                jQuery('.framework-notices').fadeOut(0, function(){
                    jQuery(this).fadeIn(500);
                });
              	jQuery('#inquiry-notice').html(str);
              	jQuery('#inquiry-notice').addClass('visible');
                setTimeout(function(){jQuery('#inquiry-notice').removeClass('visible')},3000);
            }
        }

        // hide notifications
        this.hideNotification = function(){
            jQuery('.framework-notices').fadeOut(500);
        	jQuery('#inquiry-notice').removeClass('visible')
        }

        // Returns basket items
        this.getInquiryBasketItems = function(){
            var basket = jQuery.cookie('inquiry_basket');
            var split = new Array();

            if(basket != undefined){
                split = basket.split(',');
            }
            return split;
        }

        // Load basket items
        this.loadInquiryBasketItems = function(){
            var basket = new Array();

            if(jQuery.cookie('inquiry_basket') == undefined){
                // create a new basket
                this.createNewBasket();
            }

            // then load basket items to local storage
            jQuery.each(this.getInquiryBasketItems(), function(index, val){
                basket.push(val);
            });

            inquiry_basket = basket;
        }

        // New inquiry basket session
        this.createNewBasket = function(){
            var basket = new Array();
            jQuery.removeCookie('inquiry_basket', { path: '/' });
            jQuery.cookie('inquiry_basket', basket, { expires: 7, path: '/' });
            inquiry_basket.push(basket);
        }

        // Add item to basket
        this.addItem = function(product_variant){
            inquiry_basket = this.getInquiryBasketItems();
            inquiry_basket.push(product_variant);
            this.updateBasket(inquiry_basket);
            this.showNotification('<div><i class="fa fa-check-circle"></i> Item added to inquiry list.</div>');
        }

        // update session basket items
        this.updateBasket = function(basket){
            jQuery.removeCookie('inquiry_basket', { path: '/' });
            jQuery.cookie('inquiry_basket', basket, { expires: 7, path: '/' });
            var inquiryButton = jQuery('.cart-link');
          	var item_count = 0;
          	for (i in basket)
              if (basket[i].length) item_count++;
          
            if (item_count) {
             var div = inquiryButton.find('div').first();
             if (!div.length)
               inquiryButton.append('<div>'+item_count+'</div>');
             else
              div.html(item_count)
            }
         	else
              inquiryButton.find('div').remove();
        }

        // remove item from session basket
        this.removeItem = function(product_variant){
            var items = this.getInquiryBasketItems();
            var new_basket = new Array();

            jQuery.each(items, function(key, val){
                if(val != product_variant){
                    new_basket.push(val);
                }
            });

            this.updateBasket(new_basket);
          	this.showNotification('<div class="error"><i class="fa fa-trash-o"></i> Item removed from inquiry list.</div>');
        }

        // load cart items
        this.loadCartItems = function(items){
            var container = $('#inquriy-cart-items');
            var _this = this;
            if(items.length>0){
                jQuery.each(items, function(key,item){
                    var split = item.split(':');
                    var handle = '';
                    var variant_id = '';

                    if(split.length > 1){
                        handle = split[0].trim();
                        variant_id = split[1].trim();
                    }else{
                        return true;
                    }

                    if(item.length > 0){
                        jQuery.ajax({
                            type: 'GET',
                            url: '/products/'+handle+'.js',
                            dataType: 'json',
                            success: function(data){
                                var variants = data.variants;
                                jQuery.each(variants, function(index, variant){
                                    if(variant.id == variant_id){
                                        container.append('<div class="row"><div class="columns large-4">'+ variant.sku+'</div><div class="columns large-4">'+data.title+', '+variant.title+'</div><div class="columns large-2"><button class="inquriy-cart-delete right" data-handle="'+handle+'" data-variant-id="'+variant.id+'">Remove <span class="fa fa-times"></span></button></div></div>');
                                    }
                                });

                                jQuery('.inquriy-cart-delete').bind('click', function(){
                                    var handle = jQuery(this).data('handle');
                                    var variant_id = jQuery(this).data('variant-id');
                                    // reload items
                                    _this.removeItem(handle+':'+variant_id);
                                    items = _this.getInquiryBasketItems();

                                    if(items.length > 1){
                                        _this.reloadCartItems(items);
                                    }else{
                                        jQuery('#inquiry-cart-header').css('display', 'none');
                                        container.html('<div class="text-center">No items found in your inquiry basket!</div>');
                                        jQuery('#inquiry-cart-footer').css('display', 'none');
                                    }
                                });
                            }
                        });
                    }else{
                        jQuery('#inquiry-cart-header').css('display', 'none');
                        container.html('<div class="text-center">No items found in your inquiry basket!</div>');
                        jQuery('#inquiry-cart-footer').css('display', 'none');
                    }
                });
            }else{
                container.html('No items found in your inquiry basket!');
            }
        }


        // clear cart items
        this.clearCartItems = function(){
            $('#inquriy-cart-items').html('');
        }

        // reload cart items to page
        this.reloadCartItems = function(items){
            this.clearCartItems();
            this.loadCartItems(items);
        }

        // Clears Basket Items
        this.clearInquiryBasket = function(){
            this.createNewBasket();
        }
    }
}